<script setup>
import { ref, onMounted, watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useConfirm } from "primevue/useconfirm"
import axios from "axios"
import { FilterMatchMode } from 'primevue/api'
import login1img from '../assets/images/login1.svg'
import login2img from '../assets/images/login2.svg'
import login3img from '../assets/images/login3.svg'
import login4img from '../assets/images/login4.svg'

const loader = ref(false)
const toast = useToast()
const confirm = useConfirm()

const filter_years = ref({'year': {value: 2025, matchMode: FilterMatchMode.CONTAINS}})

const filter_year = (year) => {
    filter_years.value.year.value = year
    console.log("filter_years", filter_years.value)
}

const country_code = ref('+41')
const country_codes = ref([
    {"code": "+41", "value": "+41"},
    {"code": "+49", "value": "+49"}
])
const activeTabIndex = ref(0)

const token = ref('')
const workflow_id = ref('')
const random_image_number = ref(1)
const login_image = ref(null)
const get_login_image = () => {
    random_image_number.value = Math.floor(Math.random() * 4) + 1
    if (random_image_number.value == 1) login_image.value = login1img
    if (random_image_number.value == 2) login_image.value = login2img
    if (random_image_number.value == 3) login_image.value = login3img
    if (random_image_number.value == 4) login_image.value = login4img
}

onMounted(() =>{
    get_login_image()
    token.value = localStorage.getItem('token')
    workflow_id.value = localStorage.getItem('workflow_id')
    if (token.value) {
        console.log("verify_token 1", token.value, workflow_id.value)
        verify_token()
    }
})

const login = ref(false)
const mobile = ref('')
const token_login = ref(false)
const login_error = ref(false)
const logout_message = ref(false)
const admin_login = () => {
    console.log(mobile.value)
    loader.value = true
    logout_message.value = false
    let mobile_number = mobile.value
    mobile_number = mobile_number.replace(/ /g, '')
    mobile_number = mobile_number.replace('0', country_code.value)
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/partner/login/send-2fa', {number: mobile_number, partner: "FLYINGTIGERFINANCES"})
    .then(response => {
        console.log(response.data)
        if (response.data.message == 'error') {
            toast.add({severity: 'error', summary: 'Fehler', detail: 'Es ist ein Fehler aufgetreten', life: 3000})
            login_error.value = true
            loader.value = false
        }
        if (response.data.message == 'success') {
            toast.add({severity: 'success', summary: 'SMS gesendet', detail: 'Die SMS wurde erfolgreich gesendet', life: 3000})
            token_login.value = true
            login_error.value = false
            workflow_id.value = response.data.workflow_id
            localStorage.setItem('workflow_id', workflow_id.value)
            loader.value = false
        }
    })
}

const sms_error = ref(false)
const sms_token = ref('')
const user_name = ref('')
const user_courses = ref('')
const verify_sms_token = () => {
    loader.value = true
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/partner/login/verify-sms-token', {code: sms_token.value, workflow_id: workflow_id.value})
    .then((response) => {
        console.log(response.data)
        if (response.data.message == 'success') {
            login.value = true
            token.value = response.data.token
            localStorage.setItem('token', token.value)
            user_name.value = response.data.user.name
            user_courses.value = response.data.user.courses
            sms_error.value = false
            loader.value = false
        } else {
            sms_error.value = true
            loader.value = false
        }
    })
}

const verification_loader = ref(false)
const verify_token = () => {
    verification_loader.value = true
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/partner/login/verify-token', {workflow_id: workflow_id.value, token: token.value})
    .then((response) => {
        console.log("verify_token 2", response.data)
        if (response.data.message == 'success') {
            user_name.value = response.data.user.name
            user_courses.value = response.data.user.courses
            login.value = true
            verification_loader.value = false
        } else {
            admin_logout()
            verification_loader.value = false
        }
    })
}

const admin_logout = () => {
    token.value = ''
    workflow_id.value = ''
    localStorage.removeItem('token')
    localStorage.removeItem('workflow_id')
    login.value = false
    token_login.value = false
    login_error.value = false
    sms_error.value = false
    logout_message.value = true
}

const current_date = new Date()
const current_month = current_date.getMonth() + 1
const current_year = current_date.getFullYear()

const dates = ref([
    {"month": "Januar", "month_int": 1, "year": "2024"},
    {"month": "Februar", "month_int": 2, "year": "2024"},
    {"month": "März", "month_int": 3, "year": "2024"},
    {"month": "April", "month_int": 4, "year": "2024"},
    {"month": "Mai", "month_int": 5, "year": "2024"},
    {"month": "Juni", "month_int": 6, "year": "2024"},
    {"month": "Juli", "month_int": 7, "year": "2024"},
    {"month": "August", "month_int": 8, "year": "2024"},
    {"month": "September", "month_int": 9, "year": "2024"},
    {"month": "Oktober", "month_int": 10, "year": "2024"},
    {"month": "November", "month_int": 11, "year": "2024"},
    {"month": "Dezember", "month_int": 12, "year": "2024"},
    {"month": "Januar", "month_int": 1, "year": "2025"},
    {"month": "Februar", "month_int": 2, "year": "2025"},
    {"month": "März", "month_int": 3, "year": "2025"},
    {"month": "April", "month_int": 4, "year": "2025"},
    {"month": "Mai", "month_int": 5, "year": "2025"},
    {"month": "Juni", "month_int": 6, "year": "2025"},
    {"month": "Juli", "month_int": 7, "year": "2025"},
    {"month": "August", "month_int": 8, "year": "2025"},
    {"month": "September", "month_int": 9, "year": "2025"},
    {"month": "Oktober", "month_int": 10, "year": "2025"},
    {"month": "November", "month_int": 11, "year": "2025"},
    {"month": "Dezember", "month_int": 12, "year": "2025"}
])

const open_url = (url) => {
    window.open(url, '_blank')
}

const open_api_url = (url) => {
    window.open(process.env.VUE_APP_NEURAXIS_API_MAIN + url, '_blank')
}

const swiss_date_time = (date) => {
    return new Date(date).toLocaleDateString('de-CH', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
}

const swiss_date = (date) => {
    return new Date(date).toLocaleDateString('de-CH', { year: 'numeric', month: '2-digit', day: '2-digit' })
}

const copy_to_clipboard = (value) => {
    navigator.clipboard.writeText(value)
    toast.add({severity:'success', summary: 'Erfolgreich', detail: 'In Zwischenablage kopiert', life: 3000});
}

const stock_statistics = () => {
    open_url(process.env.VUE_APP_NEURAXIS_API_MAIN + '/flyingtigerv2/export-location-stats-report')
}

const file_upload_store_excel = (e, excel_type) => {
    loader.value = true
    let reader = new FileReader()
    let file = null
    reader.readAsDataURL(e.files[0])
    reader.onload = () => {
        file = reader.result
        let payload = {
            "file": file,
            "type": excel_type
        }
        axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + "/flyingtigerv2/upload-abacus-store-export", payload)
            .then(response => {
                loader.value = false
                open_url(process.env.VUE_APP_NEURAXIS_API_MAIN + "/flyingtigerv2/download-abacus-store-export?file_name=" + response.data.file_name)
            })
    }
}

</script>

<style lang="scss" scoped>
    @import '@/core/assets/primevue/primeflex.scss';
</style>

<template>
    <Toast />
    <ConfirmDialog />
    <ProgressSpinner v-if="loader == true" style="position: fixed; z-index: 999; overflow: show; margin: auto; top: 0; left: 0; bottom: 0; right: 0; width: 50px; height: 50px;" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" aria-label="Loading..." />
    <div v-if="!verification_loader" class="flex justify-content-center mt-6">
        <div class="surface-card p-4 shadow-3 border-round" style="width: 80%" >
            <div class="flex justify-content-between">
                <img src="../assets/images/snappy_onyx_small.png" width="200" />
            </div>
            <div class="flex justify-content-end">
                <div v-if="login" class="flex justify-content-end flex-wrap" style="max-width: 200px">
                    <div class="flex align-items-center" style="width: 150px">
                        <i class="pi pi-user mr-2"></i>
                        <span>{{ user_name }}</span>
                    </div>
                    <div class="flex align-items-center mt-2 cursor-pointer hover:text-primary" style="width: 150px" @click="admin_logout()">
                        <i class="pi pi-sign-out mr-2"></i>
                        <span>Logout</span>
                    </div>
                </div>
            </div>
            <div v-if="!login" class="mt-6 p-10 fadein animation-duration-1000">
                <div class="w-full">
                    <div class="flex justify-content-center">
                        <img v-if="login_image" :src="login_image" width="400" />
                    </div>
                </div>
                <div class="w-full mt-4">
                    <div class="flex justify-content-center">
                        <h2 class="font-bold">Teacher Login</h2>
                    </div>
                </div>
                <div v-if="!token_login" class="w-full mt-6">
                    <div class="flex justify-content-center">
                        <FloatLabel>
                            <Dropdown v-model="country_code" :options="country_codes" optionLabel="code" optionValue="value" class="w-7rem mr-2" />
                            <label for="country_code">Land</label>
                        </FloatLabel>
                        <FloatLabel>
                            <InputMask id="mobile" v-model="mobile" mask="079 999 99 99" autoClear autofocus placeholder="079 123 45 67" class="w-9rem" />
                            <label for="mobile">Handy-Nr</label>
                        </FloatLabel>
                    </div>
                </div>
                <div v-if="!token_login" class="w-full">
                    <div class="mt-4 flex justify-content-center">
                        <Button :disabled="mobile.length != 13" label="Login" icon="pi pi-mobile" rounded @click="admin_login()" class="mt-2" />
                    </div>
                </div>
                <div v-if="token_login" class="w-full mt-6">
                    <div class="flex justify-content-center">
                        <FloatLabel>
                            <InputMask id="sms_token" v-model="sms_token" mask="9999" autoClear autofocus placeholder="1234" class="w-6rem" />
                            <label for="sms_token">SMS-Code</label>
                        </FloatLabel>
                    </div>
                </div>
                <div v-if="token_login" class="w-full">
                    <div class="mt-4 flex justify-content-center">
                        <Button :disabled="sms_token.length != 4" label="Login" icon="pi pi-sign-in" rounded @click="verify_sms_token()" class="mt-2" />
                    </div>
                </div>
            </div>

            <div v-if="login" class="mb-5">
                <div v-if="!loader">
                    <div class="mt-3">
                        <TabView class="col-12" ref="tabview4" v-model:activeIndex="activeTabIndex">
                            <TabPanel>
                                <template #header>
                                    <i class="pi pi-upload mr-2"></i>
                                    <span class="mr-2">Monthly stock report</span>
                                </template>
                                <div rounded class="overflow-hidden shadow-3 border-200 mt-4">
                                    <Toolbar>
                                        <template #start>
                                            <Chip label="2024" class="mr-2 bg-primary hover:bg-primary-reverse cursor-pointer" :class="filter_years.year.value == 2024 ? 'bg-green-600 text-white' : ''" @click="filter_year(2024)" />
                                            <Chip label="2025" class="mr-2 bg-primary hover:bg-primary-reverse cursor-pointer" :class="filter_years.year.value == 2025 ? 'bg-green-600 text-white' : ''" @click="filter_year(2025)" />
                                        </template>
                                    </Toolbar>
                                    <DataTable v-model:filters="filter_years" :value="dates">
                                        <Column header="Datum">
                                            <template #body="slotProps">
                                                <span>{{ slotProps.data.month }} {{ slotProps.data.year }}</span>
                                            </template>
                                        </Column>
                                        <Column header="Excel">
                                            <template #body="slotProps">
                                                <Button v-if="current_month > slotProps.data.month_int && current_year == Number(slotProps.data.year) || current_year > Number(slotProps.data.year)" label="Download" icon="pi pi-download" class="p-button-outlined" @click="open_api_url('/flyingtigerv2/export-location-stats-report?month=' + String(slotProps.data.month_int) + '&year=' + String(slotProps.data.year))" />
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel>
                                <template #header>
                                    <i class="pi pi-upload mr-2"></i>
                                    <span class="mr-2">Abacus export upload</span>
                                </template>
                                <FileUpload mode="basic" name="file[]" url="/" accept=".xls,.xlsx" :maxFileSize="10000000" :auto="true" chooseLabel="Upload: KST Auszug aus Abacus" customUpload @uploader="file_upload_store_excel($event, 'store')" />
                                <FileUpload mode="basic" name="file[]" url="/" accept=".xls,.xlsx" :maxFileSize="10000000" :auto="true" chooseLabel="Upload: Auszug HFM Head Office" customUpload @uploader="file_upload_store_excel($event, 'office')" class="mt-4" />
                            </TabPanel>
                        </TabView>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="flex justify-content-center">
                    <div class="mt-6">
                        <span class="text-gray-500">©2025 <span class="font-bold hover:text-primary cursor-pointer" @click="open_url('https://www.snappy.works')">Snappy GmbH</span>. All rights reserved.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>